import { inject, Injectable } from '@angular/core';
import { RideSalesEndpoints } from 'app/core/enums/endpoints';
import { ApiService } from 'app/services/api/api.service';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class RidesSalesService {
    private _endpoint = RideSalesEndpoints;
    private _apiService = inject(ApiService);

    constructor() {}

    // ----------------------------------------------------------------------
    // @ Public methods
    // ----------------------------------------------------------------------
    // ----------------------------------------------------------------------
    // @ CRUD methods
    // ----------------------------------------------------------------------

    /**
     * @description
     * Get all rides sales
     * @returns
     */
    getAll(playdateId: number): Observable<any> {
        return this._apiService.getOne(this._endpoint.getAll, playdateId);
    }

    /**
     * @description
     * Get single rides sale
     * @returns
     */
    getOne(id: number): Observable<any> {
        return this._apiService.getOne(this._endpoint.getOne, id);
    }

    /**
     * @description
     * Create a new rides sale
     * @returns
     */
    create(ridesSaleData: any): Observable<any> {
        return this._apiService.post(this._endpoint.create, ridesSaleData);
    }

    /**
     * @description
     * Update a rides sale
     * @returns
     */
    update(ridesSaleData: string, id: number): Observable<any> {
        return this._apiService.update(
            this._endpoint.update,
            ridesSaleData,
            id
        );
    }

    delete(id: number): Observable<any> {
        return this._apiService.delete(this._endpoint.delete, id);
    }

    /**
     * @description
     * Update a sales rep commission rate on a ride
     * @returns
     */
    updateSalesRep(data: any, id: number): Observable<any> {
        return this._apiService.update(this._endpoint.updateSalesRep, data, id);
    }

    /**
     * @description
     * Delete a sales rep from a ride commission
     * @returns
     */
    deleteSalesRep(id: number): Observable<any> {
        return this._apiService.delete(this._endpoint.deleteSalesRep, id);
    }
}
